/**
 * @generated SignedSource<<b2354f17d9e1ae80ecbc3676eaac3f89>>
 * @relayHash 368d849062587942c2c6a90b8797939e
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 368d849062587942c2c6a90b8797939e

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "envVar"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "envVar",
        "variableName": "envVar"
      }
    ],
    "kind": "ScalarField",
    "name": "env",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LayoutQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LayoutQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "368d849062587942c2c6a90b8797939e",
    "metadata": {},
    "name": "LayoutQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "2bc979af0b23a1f0038fc82543721809";

export default node;
